import { ref } from 'vue'

export const useAddAnimation = () => {
  const flyImgRef = ref(null)
  const addImageUrl = ref(null)
  const footerRef = ref(null)

  const addAnimation = (image) => {
    const flyEl = flyImgRef.value
    const cartEl = footerRef.value.cartRef

    addImageUrl.value = image

    // 获取购物车位置
    const cartRect = cartEl.getBoundingClientRect()

    // 1. 设置起始位置和初始缩放
    flyEl.style.transition = 'none'
    flyEl.style.top = '50%'
    flyEl.style.left = '50%'
    flyEl.style.transform = 'translate(-50%, -50%) scale(0)'
    flyEl.style.opacity = '1'

    requestAnimationFrame(() => {
      // 2. 中间放大动画
      flyEl.style.transition = 'transform 0.3s ease'
      flyEl.style.transform = 'translate(-50%, -50%) scale(1)'

      // 3. 放大完成后飞向购物车
      setTimeout(() => {
        flyEl.style.transition = 'all 0.6s ease-in-out'

        const targetX = cartRect.left + cartRect.width / 2 - 75
        const targetY = cartRect.top + cartRect.height / 2 - 75

        flyEl.style.top = `${targetY}px`
        flyEl.style.left = `${targetX}px`
        flyEl.style.transform = 'translate(0, 0) scale(0)'

        // 4. 飞完后隐藏 + 播放购物车弹动动画
        setTimeout(() => {
          flyEl.style.opacity = '0'

          cartEl.style.animation = 'h5-cart-bounce 0.4s ease'
          cartEl.addEventListener('animationend', () => {
            cartEl.style.animation = ''
          }, { once: true })
        }, 600)
      }, 300)
    })
  }

  return {
    flyImgRef,
    addImageUrl,
    footerRef,
    addAnimation
  }
}
